<template>
    <div
        class="app-help"
        :class="{ active: store.appHelpActive }"
    >
        <div class="app-help-header">
            <div class="app-help-header-title">Nápověda</div>
            <div
                class="close-btn"
                @click="store.appHelpActive = false"
            >
                <img src="/img/close-btn.svg" />
            </div>
        </div>
        <div class="app-help-side-panel">
            <div
                v-for="item in HelpConfig"
                :key="item.id"
                class="app-help-side-panel-item"
                @click="scrollTo(item.id)"
            >
                {{ item.title }}
            </div>
        </div>
        <div class="app-help-content">
            <div
                v-for="item in HelpConfig"
                :key="item.id"
                class="app-help-content-item"
                v-html="item.content"
            />
        </div>
    </div>
</template>

<script setup>
import HelpConfig from "./help_config.json"

const store = useMainStore()

function scrollTo(id) {
    const element = document.getElementById("help-" + id)
    element.scrollIntoView({
        block: "start",
        behavior: "smooth",
    })
}
</script>

<style lang="scss" scoped></style>
